import { PII_SERVICE_URI } from "env";
import { assertOk, proxyFetch, METHODS } from "./utils";
import { isNilOrEmpty } from "utils";

const { GET, POST } = METHODS;
export const piiProxy = proxyFetch(PII_SERVICE_URI);

export const getAccountKYCStatus = async (ctx) => {
  const response = await piiProxy(ctx, `/v1/kyc`, GET);
  assertOk(response);
  return response.json();
};

export const KYC_FORMS = {
  DOMESTIC_DV: "domestic-dv",
  DOMESTIC_NODV: "domestic-nodv",
  INTL: "international",
};

export const startKYC = async (ctx, formType) => {
  const body = isNilOrEmpty(formType)
    ? undefined
    : {
        form_type: formType,
      };
  const response = await piiProxy(ctx, "/kyc/start", POST, body);
  assertOk(response);
  const json = await response.json();
  return json;
};

export const getKYCStatus = async (ctx, KYCID) => {
  const response = await piiProxy(ctx, `/v2/kyc?kyc_id=${KYCID}`, GET);
  assertOk(response, [404]);
  return response.json();
};

export const getGDPRDocuments = async (ctx) => {
  const response = await piiProxy(ctx, "/v1/gdpr-document", GET);
  assertOk(response);
  return response.json();
};
